export const changeLang = (item) => {
    return {
        type:'CHANGE_LANG',
        payload:item
    }
}